/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { workspaceSharingsDelete } from "../../funcs/workspaceSharingsDelete.js";
import * as operations from "../../models/operations/index.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request:
    operations
      .DeleteApiWorkspaceServiceV1WorkspaceSharingsSharingIdRequest$inboundSchema,
};

export const tool$workspaceSharingsDelete: ToolDefinition<typeof args> = {
  name: "workspace-sharings_delete",
  description: `Remove workspace sharing`,
  args,
  tool: async (client, args, ctx) => {
    const [result, apiCall] = await workspaceSharingsDelete(
      client,
      args.request,
      { fetchOptions: { signal: ctx.signal } },
    ).$inspect();

    if (!result.ok) {
      return {
        content: [{ type: "text", text: result.error.message }],
        isError: true,
      };
    }

    const value = result.value;

    return formatResult(value, apiCall);
  },
};
